export const formatJson = (data: any) => {
  return JSON.stringify(data, null, '\t');
};
